import { generatePath, useNavigate, useParams } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ParamParseKey } from "react-router";

export const useGetParams = () => {
	const navigate = useNavigate();
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.HOTEL_SETTINGS.EDIT.DEFAULT>>();
	const activeLangCode = LangCode.Default;

	/**
	 * @todo hotelID ブランク時の振る舞いを設計
	 */
	if (!hotelID) {
		notifyUserEventInfo({
			title: "無効なURLです",
			description: "",
		});
		navigate(PATHS.TOP);
	}

	const navigator = {
		default: generatePath(PATHS.HOTEL.HOTEL_SETTINGS.EDIT.DEFAULT, { hotelID: hotelID! }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.HOTEL_SETTINGS.EDIT.I18N, { hotelID: hotelID!, langCode }),
	};

	return {
		hotelID: hotelID!,
		navigator,
		activeLangCode,
	};
};
